import {
  Box,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

function RoleAssignHeader({ selectedRoleData, getAllRolesData, totalFeatures }) {
  const [selectedRole, setSelectedRole] = useState(selectedRoleData || {});
  const [description, setDescription] = useState("");
  const { t } = useTranslation()
  useEffect(() => {
    if (selectedRoleData) {
      const roleData = getAllRolesData?.find(role => role.name === selectedRoleData.name);
      setSelectedRole(roleData || {});
      setDescription(roleData?.description || "");
    }
  }, [selectedRoleData, getAllRolesData]);

  const handleRoleChange = (event) => {
    const roleName = event.target.value;
    const roleData = getAllRolesData?.find(role => role.name === roleName);
    setSelectedRole(roleData || {});
    setDescription(roleData?.description || "");
  };

  return (
    <>
      <Box
        sx={{
          maxWidth: "1280px",
          height: "52px",
          borderRadius: "8px",
          gap: "16px",
          padding: "12px 24px",
          background: "#647490",
          boxShadow: "-2px 2px 5px 0px rgba(0,0,0,0.25)",
          color: "white",
          fontWeight: "bold",
          fontSize: "16px",
          display: "flex",
          alignItems: "center"
        }}
      >
        {t("Assign Features to Roles")}
      </Box>

      <Box
        sx={{
          mt: 3,
          ml: { xs: 0, sm: 1 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: "24px",
          width: "100%",
          px: { xs: 2, sm: 0 }
        }}
      >
        <div>
          <h2 style={{
            fontFamily: "Roboto",
            fontWeight: 500,
            fontSize: "20px",
            lineHeight: "100%",
            color: "#414958",
            marginBottom: "16px"
          }}>
            {t("Select Role")}
          </h2>
          <FormControl
            size="small"
            sx={{
              width: { xs: "100%", md: "360px" }
            }}
          >
            <Select
              labelId="role-select-label"
              id="role-select"
              value={selectedRole.name || ""}
              label="Select Role"
              onChange={handleRoleChange}
              className="custom-select-field"
              sx={{
                height: "55px",
                borderRadius: "16px",
                borderWidth: "2px",
                padding: "16px 24px",
                background: "#FFFFFF",
                border: "2px solid #183059",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none"
                }
              }}
            >
              {getAllRolesData?.map((role) => (
                <MenuItem key={role.id} value={role.name}>
                  {role.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div>
          <h2 style={{
            fontFamily: "Roboto",
            fontWeight: 500,
            fontSize: "20px",
            lineHeight: "100%",
            color: "#414958",
            marginBottom: "16px"
          }}>
            {t("Description")}
          </h2>
          <Box
            sx={{
              width: { xs: "100%", md: "360px" },
              height: "55px",
              borderRadius: "16px",
              padding: "16px 24px",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              bgcolor: "#f5f5f5"  // Added background color for better visibility
            }}
          >
            {description || t("No description available")}
          </Box>
        </div>
      </Box>
    </>
  );
}

export default RoleAssignHeader;
